<template>
  <div id="top" class="maincont">
    <div id="news" v-show="notice.message != '' && notice.message != null">
      <div class="ef--inner">
        <div>
          <ul>
            <li v-bind:class="noticeClass">
              <span class="date">{{ noticeDate }}</span>
              <span class="time">{{ noticeTime }}</span>
              <span class="status">{{ noticeLabel }}</span>
              <span class="article">{{ notice.message }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div id="electricalForecast">
      <div class="ef--inner">
        <h2>明日以降のでんき予報</h2>
        <div class="scroll">
          <ul>
            <li v-for="(item, index) in forecasts" :key="index">
              <div
                class="date"
                @click="onDateClick(item.datetime)"
                style="cursor: pointer;"
              >
                <span>{{ existObject(item) ? item.dateparts.month : "" }}</span
                >月
                <span>{{ existObject(item) ? item.dateparts.day : "" }}</span>
                日({{ existObject(item) ? item.dateparts.dayOfWeek : "" }})
              </div>
              <dl class="status">
                <dt>
                  <img v-bind:src="getForecastIconUrl(item.forecast_code)" />
                </dt>
                <dd>{{ getForecastString(item.forecast_code) }}</dd>
              </dl>
              <dl class="weather">
                <dt>
                  <img v-bind:src="getWeatherIconUrl(item.weather_code)" />
                </dt>
                <dd>{{ getWeatherString(item.weather_code) }}</dd>
              </dl>
              <div class="temp">
                <p class="min">
                  <span>{{ item.min_temperature }}</span
                  >℃
                </p>
                /
                <p class="max">
                  <span>{{ item.max_temperature }}</span
                  >℃
                </p>
              </div>
              <div class="other">
                <p class="precipitation">
                  <span>{{ item.rainfall }}</span
                  >mm
                </p>
                &thinsp;
                <p class="humidity">
                  <span>{{ item.humidity }}</span
                  >%
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div id="charts">
      <div class="ef--inner">
        <div id="demand">
          <h2>電力デマンド予測</h2>
          <a
            class="detail"
            v-bind:class="{ isDisabled: !hasDemandPower }"
            href="javascript:void(0);"
            @click="clickDemandDetail()"
            >詳細を見る</a
          >
          <div class="chart_wrap">

            <div v-if="hasDemandPower">
              <div id="demand_legend" v-bind:class="legendClass"></div>
              <div v-bind:class="displayDateClass">
                <div v-if="demand_time_show != null && demand_time_show != '' ">
                  <div>
                    <span>表示日時 </span>
                    <span>{{ getDemandYYYY }}年</span>
                    <span>{{ getDemandMM }}月</span>
                    <span>{{ getDemandDD }}日 </span>
                    <span>{{ getDemandStartTime }}～{{ getDemandEndTime }}</span>
                  </div>
                </div>
              </div>
              <div class="container"><canvas id="demand_canvas"></canvas></div>
            </div>

            <div v-else>
              <table>
                <caption v-if="air_conditioner_control == false">警報・注意情報一覧</caption>
                <caption v-else>注意・限界情報一覧</caption>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>発生日時</th>
                    <th>デマンド実績</th>
                    <th v-if="air_conditioner_control == false">警報/注意</th>
                    <th v-else>注意/限界</th>
                    <th>詳細</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in lteMAlarmStatusList" v-bind:key="index">
                    <td>{{ index + 1}}</td>
                    <td>{{ item.datetime }}</td>
                    <td><span>{{ item.power }}</span> kW</td>
                    <td>
                       <span v-if="(air_conditioner_control == false && item.status == 2)" class="level_alarm">警 報</span>
                       <span v-if="(air_conditioner_control == false && item.status == 1)" class="level_caution">注 意</span>
                       <span v-if="(air_conditioner_control == true && item.status == 2)" class="level_caution">注 意</span>
                       <span v-if="(air_conditioner_control == true && item.status == 1)" class="level_alarm">限 界</span>
                    </td>
                    <td><a class="table_detail" href="javascript:void(0);" @click="clickAlarmDemandDetail(item.datetime)">詳細を見る</a></td>
                  </tr>
                  <tr v-if="this.lteMAlarmStatusList == null || this.lteMAlarmStatusList.length == 0">
                    <td class="nodata" colspan="4">直近3か月でデマンド警報は発生していません。</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div id="monitoring">
          <h2>日別モニタリング</h2>
          <a
            class="detail"
            href="javascript:void(0);"
            @click="$router.push('/monitoring')"
            >詳細を見る</a
          >
          <div class="chart_wrap">
            <div id="monitoring_legend" class="legend"></div>
            <div class="scroll">
              <div class="container">
                <p class="label_left">(kW)</p>
                <p class="label_bottom">(時)</p>
                <p class="label_right">(℃)</p>
                <div style="width:542px;height:214px;">
                  <canvas id="monitoring_canvas"></canvas>
                </div>

                <ul class="weather">
                  <li v-for="(item, index) in dailyWeathers" :key="index">
                    <dl>
                      <dt>
                        <img v-bind:src="getWeatherIconUrl(item.weather)" />
                      </dt>
                      <dd
                        v-bind:class="getTempStyle(item.temperature)"
                        v-if="item.temperature != undefined"
                      >
                        <span>{{ item.temperature }}</span
                        >℃
                      </dd>
                      <dd v-bind:class="getTempStyle(item.temperature)" v-else>
                        <span>&nbsp;</span>
                      </dd>
                    </dl>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="demand-tooltip" v-bind:class="alertLevelClass">
    </div>
  </div>
</template>


<script>
/* eslint-disable */
// import Chart from "chart.js";
import Store from "../store";
import Axios from "axios";
// import $ from "jquery";
import moment from "moment";

export default {
  name: "top",
  data: function() {
    return {
      demandPower: 0,
      forecasts: [],
      dailyWeathers: [],
      alertLevelClass: "level0",
      notice: {
        level: 1,
        message: ""
      },
      chartDemand: null,
      chartMonitoring: null,
      intervalId: undefined,
      alarm_threshold: 0,
      caution_threshold: 0,
      hasDemandPower: true,
      demandGraphType: 0,
      demand_time_show: "",
      last_demand_time_show: "",
      measure_instrument: 0,
      air_conditioner_control: false,
      lteMAlarmStatusList: null,
      maxPower: 0
    };
  },
  computed: {
    noticeClass: function() {
      return "level" + this.notice.level;
    },
    noticeLabel: function() {
      return this.getNoticeLabel(this.notice.level);
    },
    noticeDate: function() {
      if (this.notice.datetime == "" || this.notice.datetime == null) {
        return "";
      } else {
        return moment
          .utc(this.notice.datetime, "YYYY/MM/DD HH:mm:ss")
          .format("MM月DD日");
      }
    },
    noticeTime: function() {
      if (this.notice.datetime == "" || this.notice.datetime == null) {
        return "";
      } else {
        return moment
          .utc(this.notice.datetime, "YYYY/MM/DD HH:mm:ss")
          .format("HH:mm");
      }
    },

    getDemandYYYY: function() {
      return moment
        .utc(this.demand_time_show, "YYYY/MM/DD HH:mm:ss")
        .format("YYYY");
    },

    getDemandMM: function() {
      return moment
        .utc(this.demand_time_show, "YYYY/MM/DD HH:mm:ss")
        .format("MM");
    },
    getDemandDD: function() {
      return moment
        .utc(this.demand_time_show, "YYYY/MM/DD HH:mm:ss")
        .format("DD");
    },
    getDemandStartTime: function() {
      return moment
        .utc(this.demand_time_show, "YYYY/MM/DD HH:mm:ss")
        .format("HH:mm");
    },
    getDemandEndTime: function() {
      return moment
        .utc(this.last_demand_time_show, "YYYY/MM/DD HH:mm:ss")
        .format("HH:mm");
    },

    legendClass: function () {
      return {
        legend: true,
        lte_legend: true
      }
    },

    displayDateClass: function () {
      return {
        display_date: true,
        current_display_date: moment.utc(moment().format("YYYY/MM/DD HH:mm:ss"), "YYYY/MM/DD HH:mm:ss").isSameOrBefore(moment.utc(this.last_demand_time_show, "YYYY/MM/DD HH:mm:ss"))
                            && moment.utc(moment().format("YYYY/MM/DD HH:mm:ss"), "YYYY/MM/DD HH:mm:ss").isSameOrAfter(moment.utc(this.demand_time_show, "YYYY/MM/DD HH:mm:ss"))
                            && this.hasDemandPower
      }
    },

    setMaxPowerClass: function() {
      let alertLevel = 1;
      if (this.maxPower >= this.alarm_threshold) {
        alertLevel = 3;
      } else if (this.maxPower >= this.caution_threshold) {
        alertLevel = 2;
      }
      console.log("FUCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC");
      this.$store.dispatch("setMaxPowerClass", `level${alertLevel}`); // ヘッダ最大電力
    }
  },
  methods: {
    onDateClick: function(date) {
      console.log(`onDateClick`);
      console.log(date);
      this.$store.dispatch("setMonitoringDate", date);
      this.$router.push("/monitoring");
    },
    clickDemandDetail: function() {
      this.$store.state.demand_datetime = "";
      this.$router.push("/demand");
    },
    clickAlarmDemandDetail: function(date) {
      var datetime = date.toString().replace(/\//g, "")
      datetime = datetime.replace(/ /g, "")
      datetime = datetime.replace(/:/g, "")
      this.$store.state.demand_datetime = "/" + datetime;
      this.$router.push("/demand");
    },

    existObject: function(object) {
      return object != undefined;
    },
    getDatePart: function(strDate) {
      const date = new Date(strDate);
      var year = date.getFullYear(); // 年
      var month = date.getMonth() + 1; // 月
      var day = date.getDate(); // 日
      var hour = date.getHours(); // 時
      var minute = date.getMinutes(); // 分
      var second = date.getSeconds(); // 秒
      var dayOfWeek = date.getDay(); // 曜日(数値)
      return {
        month: month,
        day: day,
        dayOfWeek: ["日", "月", "火", "水", "木", "金", "土"][dayOfWeek]
      };
    },
    drawDemandChart: function(newData) {
      console.log(`drawDemandChart`);

      const self = this;
      let measure = [];
      let demand = [];
      let alarm_demand = [];
      let alarm_thresholds = [];
      let caution_power = [];
      let limit_power = [];
      let line_length = 7;
      let labels = ["0", "5", "10", "15", "20", "25", "30"];
      if (this.measure_instrument == 2 || this.measure_instrument == 3) {
        line_length = 31;
        labels = ["0", "", "", "", "", "5"
                , "", "", "", "", "10"
                , "", "", "", "", "15"
                , "", "", "", "", "20"
                , "", "", "", "", "25"
                , "", "", "", "", "30"];
      }

      for (let i = 0; i < line_length; i++) {
        caution_power.push(newData.caution_power);
      }
      
      for (let i = 0; i < line_length; i++) {
        limit_power.push(newData.limit_power);
      }

      newData.demand.forEach(element => {
        demand.push(element.power);
      });

      // this.demandPower = demand.slice(-1)[0];

      newData.measure.forEach(element => {
        measure.push(element.power);
      });

      if (demand.length == 0) {
        this.demandPower = measure.slice(-1)[0];
      } else {
        this.demandPower = demand.slice(-1)[0];
      }
      this.$store.dispatch("setDemandPower", this.demandPower); // ヘッダ現在値

      this.$store.dispatch("setCurrentPower", measure.slice(-1)[0]); // ヘッダ予測値
      demand = measure.concat(demand);

      this.alarm_threshold = newData.alarm_threshold;
      this.caution_threshold = newData.caution_threshold;

      for (let index = 0; index < line_length; index++) {
        // alarm_threshold.push(newData.alarm_threshold);
        alarm_thresholds.push(this.alarm_threshold);
      }

      if (this.demandGraphType != 1) {
        alarm_demand = measure.slice(0, line_length - newData.alarm_demand.length);
        newData.alarm_demand.forEach(element => {
          alarm_demand.push(element.power);
        });
        for (let i = (line_length - newData.alarm_demand.length); i < (alarm_demand.length - 1); i++) {
          alarm_demand[i] = null;
        }
      }
      let alarm_demand_hidden_flg = Boolean(true);
      if (alarm_demand[alarm_demand.length - 1] > 0) {
        alarm_demand_hidden_flg = false;
      }

      const demand_time = newData.demand_time.split(" ")[1];
      this.demand_time_show = newData.demand_time;
      this.last_demand_time_show= newData.last_datetime;
      const lastValue = this.demandPower;

      let alertLevel = 1;
      if (this.demandGraphType == 3 && newData.air_conditioner_id_count > 0) {
        this.$store.dispatch("setAirConditionerIdFlag", true);
        if (newData.control_status == 1) {
          alertLevel = 3;
        } else if (newData.control_status == 2) {
          alertLevel = 2;
        } else {
          alertLevel = 1;
        }
      } else {
        this.$store.dispatch("setAirConditionerIdFlag", false);
        if (lastValue >= this.alarm_threshold) {
          alertLevel = 3;
        } else if (lastValue >= this.caution_threshold) {
          alertLevel = 2;
        } else {
          alertLevel = 1;
        }
      }

      this.alertLevelClass = `level${alertLevel}`;

      this.$store.dispatch("setAlertLevelClass", this.alertLevelClass);
      console.log(`this.alarm_threshold= %o`, this.alarm_threshold);
      console.log(`this.caution_threshold= %o`, this.caution_threshold);
      console.log(`this.alertLevelClass= %o`, this.alertLevelClass);

      console.log(this.alertLevelClass);

      console.log("measure=%o", measure);
      console.log("demand=%o", demand);
      
      let demand_kw_step = this.getStepSize(newData.power_max);
      
      for (let index = measure.length; index < demand.length - 1; index++) {
        demand[index] = null;
      }

      console.log("measure=%o", measure);
      console.log("demand=%o", demand);
      // T&D
      var e1 = {
        labels: labels,
        datasets: [
          {
            type: "line",
            label: "デマンド実績",
            data: measure,
            borderColor: "rgba(50,100,255,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: true,
            backgroundColor: "rgba(49, 99, 255, 0.1)"
          },
          {
            type: "line",
            label: "デマンド予測",
            data: demand,
            borderColor: "rgba(206,133,255,1.0)",
            fill: false,
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            spanGaps: true
            // pointRadius: 0,
            // pointHoverRadius: 0,
            // pointHitRadius: 0
          },
          {
            type: "line",
            label: "警報閾値",
            data: alarm_thresholds,
            borderColor: "rgba(238,77,77,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }
        ]
      };
      // 渡辺電機（空調機制御無し）
      var e2 = {
        labels: labels,
        datasets: [
          {
            type: "line",
            label: "デマンド実績",
            data: measure,
            borderColor: "rgba(50,100,255,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: true,
            backgroundColor: "rgba(49, 99, 255, 0.1)"
          },
          {
            type: "line",
            label: "デマンド予測",
            data: demand,
            borderColor: "rgba(206,133,255,1.0)",
            fill: false,
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            spanGaps: true
            // pointRadius: 0,
            // pointHoverRadius: 0,
            // pointHitRadius: 0
          },
          {
            type: "line",
            label: "警報時デマンド予測",
            data: alarm_demand,
            borderColor: "rgba(150,150,150,1.0)",
            fill: false,
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            spanGaps: true,
            // pointRadius: 0,
            // pointHoverRadius: 0,
            // pointHitRadius: 0
            borderDash: [7, 7],
            hidden: alarm_demand_hidden_flg
          },
          {
            type: "line",
            label: "警報閾値",
            data: alarm_thresholds,
            borderColor: "rgba(238,77,77,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }
        ]
      };
      // 渡辺電機（空調機制御有り）
      var e3 = {
        labels: labels,
        datasets: [
          {
            type: "line",
            label: "デマンド実績",
            data: measure,
            borderColor: "rgba(50,100,255,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: true,
            backgroundColor: "rgba(49, 99, 255, 0.1)",
            //pointBorderWidth: 3,
            //pointRadius: 4,
            //spanGaps: true
          },
          {
            type: "line",
            label: "デマンド予測",
            data: demand,
            borderColor: "rgba(206,133,255,1.0)",
            fill: false,
            //pointBorderWidth: 3,
            //pointRadius: 4,
            spanGaps: true
          },
          {
            type: "line",
            label: "警報時デマンド予測",
            data: alarm_demand,
            borderColor: "rgba(150,150,150,1.0)",
            pointBackgroundColor: "rgba(255,255,255,0.8)",
            fill: false,
            //pointBorderWidth: 3,
            //pointRadius: 4,
            spanGaps: true,
            borderDash: [7, 7],
            hidden: alarm_demand_hidden_flg
          },
          {
            type: "line",
            label: "注意電力",
            data: caution_power,
            borderColor: "rgba(252,187,149,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "line",
            label: "限界電力",
            data: limit_power,
            borderColor: "rgba(246,166,166,1.0)",
            fill: false,
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }
        ]
      };
      var c = {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(k) {
          var l = [];
          l.push('<ul class="' + k.id + '-legend">');
          console.log(k.data.datasets.length);
          for (var j = 0; j < k.data.datasets.length; j++) {
            l.push("<li><span>");
            if (k.data.datasets[j].label) {
              l.push(k.data.datasets[j].label);
            }
            l.push("</span></li>");
          }
          l.push("</ul>");
          return l.join("");
        },
        elements: { line: { tension: 0 } },
        scales: {
          xAxes: [
            {
              ticks: { maxRotation: 0, minRotation: 0 },
              gridLines: { display: false, drawOnChartArea: false }
            }
          ],
          yAxes: [
            {
              display: true,
              ticks: {
                max: newData.power_max,
                min: newData.power_min,
                stepSize: demand_kw_step
              }
            }
          ]
        },
        tooltips: {
          enabled: false,
          custom: function(m) {
            if (m.opacity === 0) {
              $("#demand-tooltip").css("opacity", 0);
              return;
            }

            function h(n) {
              return n.lines;
            }

            if (m.body) {
              var i = m.body.map(h);
              var time;
              var demands;
              var xPoint;
              var yPoint;

              i.forEach(function(n) {
                time = n[0];
                demands = n[1];
                xPoint = n[2];
                yPoint = n[3];
              });
            }

            var tooltip = document.getElementById("demand-tooltip");
            var innerHtml = "";
            innerHtml += "<dl>";
            innerHtml += ("<dt><span style=\"font-size:20px;\">" + time + "</span></dt>");
            innerHtml += "<table style=\"border:0px;\">";
            innerHtml += "<tbody style=\"border:0px;\">";
            demands.forEach(function(info) {
              innerHtml += "<tr style=\"border:0px;\">";
              innerHtml += ("<td style=\"width:135px; text-align:left;\">" + info[0] + "</td>");
              innerHtml += ("<td style=\"text-align:right;\"><span style=\"font-size:24px;\">" + info[1] + "</span>kW</td>");
              innerHtml += "</tr>";
            });
            innerHtml += "</tbody>";
            innerHtml += "</table>";
            innerHtml += "</dl>";
            tooltip.innerHTML = innerHtml;
            var e = this._chart.canvas.getBoundingClientRect();
            var g = e.left + window.pageXOffset + parseFloat(xPoint) - $("#demand-tooltip").outerWidth() / 2;
            var f = e.top + window.pageYOffset + parseFloat(yPoint) - $("#demand-tooltip").outerHeight() - 20;
            $("#demand-tooltip").css({
              display: "block",
              opacity: 1,
              position: "absolute",
              left: g,
              top: f,
              pointerEvents: "none"
            });
          },
          callbacks: {
            label: function(f, g) {
              var time = "";
              var cur_datetime=new Date(newData.demand_time);
              if (g.labels[f.index] == "") {
                cur_datetime.setSeconds(cur_datetime.getSeconds() + Number(f.index)*60);
              } else {
                cur_datetime.setSeconds(cur_datetime.getSeconds() + Number(g.labels[f.index])*60);
              }
              
              time = ("00" + cur_datetime.getHours().toString()).slice(-2) + ":" + ("00" + cur_datetime.getMinutes().toString()).slice(-2);

              var demands = [];
              if ((f.datasetIndex == 2) && (f.index == (g.datasets[2].data.length - 1)) && (g.datasets[2].label == "警報時デマンド予測")) {
                demands.push(["警報時デマンド予測", g.datasets[2].data[g.datasets[2].data.length - 1]]);
              } else if (g.datasets[0].data.length == g.datasets[1].data.length) {
                demands.push(["デマンド実績", g.datasets[0].data[f.index]]);
              } else if ((f.index == (g.datasets[1].data.length - 1)) && (g.datasets[0].data.length < g.datasets[1].data.length)) {
                demands.push(["デマンド予測", g.datasets[1].data[g.datasets[1].data.length - 1]]);
              } else {
                demands.push(["デマンド実績", g.datasets[0].data[f.index]]);
                demands.push(["デマンド予測", g.datasets[1].data[g.datasets[1].data.length - 1]]);
              }
              d = [time, demands, f.x, f.y];

              return d;
            }
          }
        }
      };
      var a = document.getElementById("demand_canvas").getContext("2d");
      var d = a.createLinearGradient(0, 0, 0, 190);
      d.addColorStop(0, "rgba(113, 147, 255, 1)");
      d.addColorStop(1, "rgba(193, 208, 255, 1)");

      if (this.chartDemand != null) {
        this.chartDemand.destroy();
      }

      var obj_id = "demand_legend";
      var demand_legend = document.querySelector("#demand_legend");
      if (this.demandGraphType == 1) {
        obj_id = "demand_legend_1";
        this.chartDemand = new Chart(a, { type: "line", data: e1, options: c });
      } else {
        if (this.demandGraphType == 2) {
          obj_id = "demand_legend_2";
          this.chartDemand = new Chart(a, { type: "line", data: e2, options: c });
        } else {
          obj_id = "demand_legend_3";
          this.chartDemand = new Chart(a, { type: "line", data: e3, options: c });
        }
      }
      demand_legend.innerHTML = this.chartDemand.generateLegend();
      demand_legend.id = obj_id;
    },
    drawMonitoringChart: function(newData) {
      console.log("drawMonitoringChart");
      const todayStr = moment().format("YYYY/MM/DD");
      const timeTable48 = this.createMonitoringTimeTable48(todayStr);
      const timeTable24 = this.createMonitoringTimeTable24(todayStr);
      const timeTable12 = this.createMonitoringTimeTable12(todayStr);

      const self = this;
      let demand = Array(48).fill(null);
      newData.demand.forEach(element => {
        const index = timeTable48.indexOf(element.datetime);
        demand[index] = element.demand;
      });

      const maxPower = Math.max.apply(null, demand);
      this.$store.dispatch("setMaxPower", maxPower); // ヘッダ最大電力

      let alertLevel = 1;
      if (maxPower >= newData.alarm_threshold) {
        alertLevel = 3;
      } else if (maxPower >= newData.caution_threshold) {
        alertLevel = 2;
      }

      this.$store.dispatch("setMaxPowerClass", `level${alertLevel}`); // ヘッダ最大電力
      // this.alertLevelClass = `level${alertLevel}`;

      let temperature_actual = Array(48).fill(null);
      for (let index = 0; index < newData.temperature_actual.length; index++) {
        const element = newData.temperature_actual[index];
        const datetime = element["datetime"];

        const pos = timeTable48.indexOf(String(datetime));

        temperature_actual[pos] = element.temperature;
      }

      let temperature_forecast = Array(48).fill(null);
      for (
        let index = 0;
        index < newData.temperature_forecast.length;
        index++
      ) {
        const element = newData.temperature_forecast[index];
        const datetime = element["datetime"];

        const pos = timeTable48.indexOf(String(datetime));

        temperature_forecast[pos] = element.temperature;
      }

      this.dailyWeathers = Array(12).fill({
        weather: undefined,
        temperature: undefined
      });

      newData.weather.forEach(element => {
        const index = timeTable12.indexOf(element.datetime);

        self.dailyWeathers[index] = {
          weather: element.weather,
          temperature: element.temperature
        };
      });

      const power_max = newData.power_max;

      var a = document.getElementById("monitoring_canvas").getContext("2d");
      var d = a.createLinearGradient(0, 0, 0, 190);
      d.addColorStop(0, "rgba(113, 147, 255, 1)");
      d.addColorStop(1, "rgba(193, 208, 255, 1)");

      let demand_kw_step = this.getStepSize(newData.demand_max);

      var h = {
        labels: [
          "0:00",
          "0:30",
          "1:00",
          "1:30",
          "2:00",
          "2:30",
          "3:00",
          "3:30",
          "4:00",
          "4:30",
          "5:00",
          "5:30",
          "6:00",
          "6:30",
          "7:00",
          "7:30",
          "8:00",
          "8:30",
          "9:00",
          "9:30",
          "10:00",
          "10:30",
          "11:00",
          "11:30",
          "12:00",
          "12:30",
          "13:00",
          "13:30",
          "14:00",
          "14:30",
          "15:00",
          "15:30",
          "16:00",
          "16:30",
          "17:00",
          "17:30",
          "18:00",
          "18:30",
          "19:00",
          "19:30",
          "20:00",
          "20:30",
          "21:00",
          "21:30",
          "22:00",
          "22:30",
          "23:00",
          "23:30",
          "24:00"
        ],
        datasets: [
          {
            type: "line",
            label: "予報気温",
            data: temperature_actual,
            borderColor: "rgba(27,200,152,1.0)",
            fill: false,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "line",
            label: "実測気温",
            data: temperature_forecast,
            borderColor: "#FAC090",
            fill: false,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "bar",
            label: "デマンド実績",
            data: demand,
            backgroundColor: d,
            hoverBackgroundColor: d,
            yAxisID: "y-axis-2",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }
        ]
      };
      var f = {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(k) {
          var l = [];
          l.push('<ul class="' + k.id + '-legend">');
          for (var f = 0; f < k.data.datasets.length; f++) {
            switch (f) { 
              case 0: // 予報気温
                l.push("<li id='day-legend'><span>");
                l.push(k.data.datasets[f+2].label);
                break;
              case 1: // 実測気温
                l.push("<li id='day-legend'><span>");
                l.push(k.data.datasets[f].label);
                break;
              case 2: // デマンド実績
                l.push("<li id='day-legend'><span>");
                l.push(k.data.datasets[f-2].label);
                break;
            }
          }
          l.push("</ul>");
          return l.join("");
        },
        elements: {
          line: {
            tension: 0
          },
          point: {
            radius: 0
          }
        },
        scales: {
          xAxes: [
            {
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                autoSkip: true,
                maxTicksLimit: 13
              },
              gridLines: {
                display: false,
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              id: "y-axis-2",
              type: "linear",
              position: "left",
              ticks: {
                max: newData.demand_max,
                min: newData.demand_min,
                stepSize: demand_kw_step
              }
            },
            {
              id: "y-axis-1",
              type: "linear",
              position: "right",
              ticks: {
                max: newData.temperature_max,
                min: newData.temperature_min,
                stepSize: 10
              },
              gridLines: {
                drawOnChartArea: false
              }
            }
          ]
        },
        tooltips: {
          enabled: false
        }
      };
      if (this.chartMonitoring != null) {
        this.chartMonitoring.destroy();
      }
      this.chartMonitoring = new Chart(
        document.getElementById("monitoring_canvas").getContext("2d"),
        {
          type: "bar",
          data: h,
          options: f
        }
      );
      $("#monitoring_legend").html(this.chartMonitoring.generateLegend());
      $("#monitoring_legend").off("click", "li");
      $("#monitoring_legend").on("click", "li", function() {
        $(this).toggleClass("hide");
        var i = $(this).index();
        if (i == 2) {
          i = 1;
        } else if (i == 1) {
          i = 0;
        } else {
          i = 2;
        }
        var j = self.chartMonitoring.getDatasetMeta(i);
        j.hidden =
          j.hidden === null
            ? !self.chartMonitoring.data.datasets[i].hidden
            : null;
        self.chartMonitoring.update();
      });
    },
    getStepSize(value) {
      let stepSize = 20;
      if (value > 100) {
        stepSize = Math.floor(value / 100) * 10;
      }
      return stepSize;
    }
  },
  mounted: function() {
    console.log("mounted");
    const self = this;

    // リロードタイマー登録
    this.intervalId = setInterval(function() {
      console.log("reload");
      location.reload();
    }, Store.state.reloadTime);

    // アカウントデータ取得
    this.$axios
      .get(`/srv/api/account/${Store.state.childID}`, {
        withCredentials: true
      })
      .then(response => {
        console.log(response.data);
        Store.dispatch("setChildInfo", response.data);
        this.measure_instrument = Store.state.childInfo.power_info['measure_instrument'];
      })
      .catch(error => {
        console.log(error);
      });

    // 天気予報取得
    this.$axios
      .get(`/srv/api/forecast/${Store.state.childID}`, {
        withCredentials: true
      })
      .then(response => {
        console.log(response.data);
        //
        if (response.data.hasOwnProperty("forecast")) {
          let temp = response.data["forecast"];
          temp.forEach(element => {
            element["dateparts"] = this.getDatePart(element.datetime);
          });
          this.forecasts = temp;
        } else {
          this.forecasts = [];
        }
      })
      .catch(error => {
        this.forecasts = [];
      });

    // 注意情報取得
    this.$axios
      .get(`/srv/api/notice/`, {
        withCredentials: true
      })
      .then(response => {
        console.log("notice=");
        console.log(response.data);
        this.notice = response.data;
      })
      .catch(error => {
        console.log(error);
      });

    // デマンドデータ取得
    this.$axios
      .get(`/srv/api/demand/${Store.state.childID}`, {
        withCredentials: true
      })
      .then(response => {
        console.log(response.data);
        this.measure_instrument = response.data.measure_instrument;
        if ((response.data.air_conditioner_control == true) && (response.data.air_conditioner_id_count > 0)) {
          this.air_conditioner_control = true;
        } else {
          this.air_conditioner_control = false;
        }
        if (this.measure_instrument == 2 
            && response.data.demand.length == 0
            && response.data.measure.length == 0) {
          this.hasDemandPower = false;
        } else {
          this.hasDemandPower = true;
        }
        if (this.hasDemandPower == true) {
          if (this.measure_instrument == 1) {
            this.demandGraphType = 1;
          } else {
            if (this.air_conditioner_control == false) {
              this.demandGraphType = 2;
            } else {
              this.demandGraphType = 3;
            }
          }
        }

        this.lteMAlarmStatusList = response.data.lteMAlarmStatusList;
        self.drawDemandChart(response.data);
      })
      .catch(error => {
        console.log(error);
      });

    // 日間モニタリングデータ取得
    const today = moment(new Date()).format("YYYY/MM/DD");
    this.$axios
      .post(
        `/srv/api/daytoday/${Store.state.childID}`,
        { date: today },
        {
          withCredentials: true
        }
      )
      .then(response => {
        console.log(response.data);
        self.drawMonitoringChart(response.data);
      })
      .catch(error => {
        console.log(error);
        // this.$store.dispatch("logout");
        // this.$router.push("/login");
      });
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    // reset reload timer
    clearInterval(this.intervalId);
  }
};
</script>
